import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import {
  collectDestinationCidrs,
  destinationSchema,
} from "./egressRouteShared";
import { mutator } from "./mutator";

const updateEgressRouteSchema = z.object({
  id: z.string(),
  destination: destinationSchema.optional(),
  enforced: z.boolean().optional(),
  spaceId: z.string().nullish(),
});

export const updateEgressRoute = mutator({
  description:
    "Updates a tunnel destination route and the spaces it applies to.",
  interactionType: "update",
  schema: updateEgressRouteSchema,
  resolve: {
    egressRoute: { kind: "egressRoute", from: "id" },
    space: { kind: "space", from: "spaceId", optional: true },
  },
  permissions: [
    {
      permission: "tenant:egress_routes_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
    {
      permission: "network:use",
      scopeId: ({ args }) => args.egressRoute.network.id,
    },
  ],
  fn: async ({
    tx,
    args: { destination, enforced, egressRoute, spaceId, space },
  }) => {
    const route = destination && {
      destinationType: destination.type,
      destination:
        destination.type === "cidr" ? destination.range : destination.pattern,
    };
    await tx.mutate.egressRoutes.update({
      id: egressRoute.id,
      ...route,
      enforced: enforced ?? egressRoute.enforced,
      spaceId:
        spaceId === undefined ? egressRoute.spaceId : (space?.id ?? null),
    });
    if (!route) return;
    const { network } = egressRoute;
    const existing = await tx.run(
      zql.egressRoutes.where("networkId", network.id)
    );
    const next = existing.map((r) => (r.id === egressRoute.id ? route : r));
    await tx.mutate.networks.update({
      id: network.id,
      configuration: {
        ...network.configuration,
        destinationCidrs: collectDestinationCidrs(next),
      },
    });
  },
});
